<div class="page">

    <!--
    ========================================================
                                CONTENT
    ========================================================
    -->
    <main>
        <section style="height: 180px;" data-url="assets/images/HI-TEC-kokoonpano-Evetco.jpg" data-mobile="true"
                 class="well3 center parallax">
            <div class="container">
            </div>
        </section>
        <section class="well center bg-color">
            <div class="container">
                <h3>{{"ABOUT.TITLE" | translate}}</h3><img src="assets/images/FVM 500F logoin.jpg"
                                                           style="max-height: 500px;width: 1200px;object-fit: contain;"
                                                           alt="">
                <h5>{{"ABOUT.FIRST" | translate}}</h5>
                <p class="txt1">{{"ABOUT.SECOND" | translate}}</p>
                <hr style="margin: 25px"/>
                <h6><a target="_blank" [href]="'BROCHURE-URL' | translate" >{{"DOWNLOAD-BROCHURE" | translate}}</a></h6>
            </div>
        </section>
        <section data-url="assets/images/DSC00441-1024x768.png" data-mobile="true" class="well3 center parallax">
            <div class="container">
                <h3 style="color: white">{{"ABOUT.EXPERIENCE" | translate}}</h3>
                <p class="txt1">{{"ABOUT.THIRD" | translate}}</p>
            </div>
        </section>
        <section class="well bg-color">
            <div class="container">
                <h3 class="center">{{"NAV.PRODUCTS" | translate}}</h3>
                <ul class="row product-list2">
                    <li class="grid_4">
                        <figure class="figure"><img src="assets/images/Kaivurit.jpg" class="square-image" alt="">
                            <figcaption data-equal-group="1">
                                <h6><a href="#">{{"ABOUT.TUOTTEET" | translate}}</a></h6>
                                <p style="height: 210px;" class="txt1">{{"ABOUT.TUOTTEETDESC" | translate}}</p>
                                <a (click)="redirect('/products/excavators')" class="btn">{{"READMORE" | translate}}</a>
                            </figcaption>
                        </figure>
                    </li>
                    <li class="grid_4">
                        <figure class="figure"><img src="assets/images/Kelamurskaimet.jpg" class="square-image"
                                                    alt="">
                            <figcaption data-equal-group="1">
                                <h6><a href="#">{{"ABOUT.TUOTTEET2" | translate}}</a></h6>
                                <p style="height: 210px;" class="txt1">{{"ABOUT.TUOTTEETDESC2" | translate}}</p>
                                <a (click)="redirect('/products/mulchers')" class="btn">{{"READMORE" | translate}}</a>
                            </figcaption>
                        </figure>
                    </li>
                    <li class="grid_4">
                        <figure class="figure"><img src="assets/images/Erikoissovellukset-miina.jpg" class="square-image"
                                                    alt="">
                            <figcaption data-equal-group="1">
                                <h6><a href="#">{{"ABOUT.TUOTTEET3" | translate}}</a></h6>
                                <p style="height: 210px;" class="txt1">{{"ABOUT.TUOTTEETDESC3" | translate}}</p>
                                <a (click)="redirect('/products/special')" class="btn">{{"READMORE" | translate}}</a>
                            </figcaption>
                        </figure>
                    </li>
                </ul>
            </div>
        </section>
        <section>
            <div class="videoWrapper">
                <iframe style="width: 100%; height: 60vh" src="https://www.youtube.com/embed/AUPYYSvsBEU?controls=0"
                        frameborder="0" allowfullscreen></iframe>
            </div>
        </section>
        <section class="map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7700.310993761187!2d21.55269!3d61.1513486!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xda0f0fe9ad47d7dd!2sEvetco%20Ky!5e0!3m2!1sfi!2sfi!4v1598541196282!5m2!1sfi!2sfi"
                    width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false"
                    tabindex="0"></iframe>
        </section>
    </main>
</div>
